import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class ProductionOrderService {
    constructor(private datatask: DataTaskService) {}

    /** @datatask 492 */
    public async getSelectionSettings(params: { webpagename: string }): Promise<PoFinishSelectionGet> {
        return (await this.datatask.Post(492, params))[0];
    }
    /** @datatask 447 */
    public listFinishedOrders(params: { select_type: string }): Promise<ProductionOrderSelectionItem[]> {
        return this.datatask.Post(447, params);
    }
    /** @datatask 493 */
    public listProductionOrders(params: { stockplace_id: string; operation_id: string }): Promise<ProductionOrderSelectionItem[]> {
        return this.datatask.Post(493, params);
    }
    /** @datatask 154 */
    public scanProductionOrder(params: { barcode?: string }): Promise<ProductionOrderScan[]> {
        return this.datatask.Post(154, params);
    }
    /** @datatask 448 */
    public async selectFinishedOrder(params: { p2_pofinish_keyno: string | number; webpagename: string }): Promise<void> {
        await this.datatask.Post(448, params);
    }
}

export interface PoFinishSelectionGet {
    filtervalue?: string;
    stockplace_id?: string;
    stockplace_name?: string;
    operation_id?: string;
    operation_name?: string;
}
export interface ProductionOrderSelectionItem extends Item {
    item_id: string;
    item_name: string;
    barcode?: string;
}
export interface ProductionOrderScan {
    p2_pofinish_keyno: string | number;
}
